export default __webpack_public_path__ + "static/media/mynextLogo.25658e59.svg";